import messageResource from '../messageResource'
import SelectorPanelWithApplyButtonHelper from './selectorControls/at_selector_panel_with_apply_button_object'
import Ext from 'Ext'
import SelectorDropdownButton from './selectorControls/at_selector_dropdown_button'

export default function LeaveTypesSelectorButton() {}

LeaveTypesSelectorButton.prototype.init = function({
        renderTo,
        leavesSelection,
        leavesData,
        ptoFeatureEnabled,
        sickBalanceFeatureEnabled,
        changeCallback,
        withApplyButton,
        extraClass = '',
        isMarkAllSelectedIfEmpty = false,
        showInactiveCheckbox = false,
        isMarkAllSelectedIfEmptyOnInit = true,
        labelNoItemsSelectedKey = 'leaves_selector.label.no_items_selected',
    })
{
    const leaveSelectorUtil = new LeaveTypesSelectorUtil().init(leavesData, ptoFeatureEnabled, sickBalanceFeatureEnabled, leavesSelection.leaveTypes);

    const ptoName = messageResource.getMessage("leaves_selector.group_label.pto_balance");
    const sdbName = messageResource.getMessage("leaves_selector.group_label.sick_days_balance");
    const bothName = ptoFeatureEnabled && sickBalanceFeatureEnabled ?
        messageResource.getMessage("leaves_selector.group_label.both") : ptoFeatureEnabled ? ptoName : sdbName;

    const leaveSelectorData = leaveSelectorUtil.getDataForSelector(
        {
            ptoLabel : messageResource.getMessage('leaves_selector.group_label.affects', [ptoName]),
            sickDaysLabel : messageResource.getMessage('leaves_selector.group_label.affects', [sdbName]),
            withoutBalancesLabel : messageResource.getMessage('leaves_selector.group_label.does_not_affect', [bothName])
        }
    );

    const markupAllIfEmptyConfig = isMarkAllSelectedIfEmpty ? {allItemsOptionValue: true, customOptionValue: false} : {}

    const leavesConfig = {
        data: leaveSelectorData,
        optionValue: leavesSelection.qualifier,
        showInactive: leaveSelectorUtil.isNeedToShowInactiveLeaves() || leavesSelection.showInactive,
        showResetButton: true,
        isMarkAllSelectedIsEmpty: isMarkAllSelectedIfEmpty,
        showShowInactiveCheckbox: showInactiveCheckbox,
        isMarkAllSelectedIfEmptyOnInit,
        labelNoItemsSelectedKey,
        ...markupAllIfEmptyConfig,
    };

    const panelConstructor = AT.ReportLeavesSelectorPanel;
    leaveSelectorUtil.setSelectorTreeConstructorToPanel(panelConstructor);

    if ( withApplyButton )
        Ext.apply( leavesConfig, SelectorPanelWithApplyButtonHelper.getApplyButtonExtension( panelConstructor ) );
    const leavesSelector = new panelConstructor( leavesConfig );

    const self = this;
    leavesSelector.on("change", function() {
        self.leavesSelector.wasChanged = true;
    });

    this.leavesSelector = new SelectorDropdownButton({
        additionalMenuCls: 'leaveTypeSelector ' + extraClass,
        renderTo: renderTo,
        labelCls: "hierarchySelectorButton",
        minWidth: 457,
        selectorPanel: leavesSelector
    });

    this.leavesSelector.setMenuHideCallback(function(){
        if (changeCallback && (self.leavesSelector.wasChanged || self.leavesSelector.selectorPanel.isNeedToMarkAllSelected())) {
            self.leavesSelector.wasChanged = false
            self.leavesSelector.selectorPanel.markAllSelectedIfNeeded()
            changeCallback()
        }
    });

    return this;
};

LeaveTypesSelectorButton.prototype.getLeaveTypeSelection = function ()
{
    const leavesSelector = this.leavesSelector.selectorPanel;
    const leaveTypes = [];
    for ( let i = 0; i < leavesSelector.getSelection().length; ++i ) {
        leaveTypes.push(leavesSelector.getSelection()[i].id);
    }

    return  {
        leaveTypes: leaveTypes,
        qualifier: leavesSelector.getCurrentOptionValue(),
        showArchived: leavesSelector.getShowInactive()
    };
};

LeaveTypesSelectorButton.prototype.resetLeavesSelectionFunction = function()
{
    this.leavesSelector.selectorPanel.resetState(true);
};

LeaveTypesSelectorButton.prototype.setInitialValuesFromCurrent = function()
{
    this.leavesSelector.selectorPanel.setInitialValuesFromCurrent();
};

LeaveTypesSelectorButton.prototype.isEmptySelection = function()
{
    return this.leavesSelector.selectorPanel.isEmptySelection();
};

LeaveTypesSelectorButton.prototype.isStateChanged = function()
{
    return this.leavesSelector.selectorPanel.isStateChanged();
};


// WEBPACK FOOTER //
// ./web/js/controls/LeaveTypesSelectorButton.js